import { z } from 'zod'

export const establishmentTechnicalProfessionalCreateSchema = z.object({
  display_name: z
    .string()
    .trim()
    .min(3, { message: 'Tamanho mínimo: 3 caracteres' })
    .max(64, { message: 'Tamanho máximo: 64 caracteres' }),
})

export type EstablishmentTechnicalProfessionalValidationSchema = z.infer<
  typeof establishmentTechnicalProfessionalCreateSchema
>
